import React from "react";
import { Box, Button, GridItem } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import {
  AccordionItem,
  Grid,
  ImageUploader,
  PageHeader,
  TextInput,
  Form
} from "components";
import { useCreateOrganization, getValidation } from "./duck";

const Create: React.FC = () => {
  const create = useCreateOrganization();

  return (
    <>
      <PageHeader title="Create Organization" backURL={-1} />
      <Box mt={6}>
        <Form {...getValidation()} onSubmit={create}>
          <Box mt={6}>
            <AccordionItem title="General">
              <Grid templateColumns="repeat(2, 1fr)">
                <GridItem>
                  <TextInput
                    name="organizationName"
                    label="Name"
                    placeholder="Organization Name"
                  />
                </GridItem>
                <GridItem>
                  <TextInput
                    name="organizationDescription"
                    label="Description"
                    placeholder="Description"
                  />
                </GridItem>
                <GridItem>
                  <TextInput
                    name="organizationContactEmail"
                    label="Contact Email"
                    placeholder="Contact Email"
                  />
                </GridItem>
                <GridItem colStart={1}>
                  <ImageUploader
                    allowedTypes={["svg"]}
                    name="organizationLogo"
                    label="Organization Logo"
                  />
                </GridItem>
              </Grid>
            </AccordionItem>
          </Box>

          <Box mt={6}>
            <AccordionItem title="Organization Admin">
              <Grid templateColumns="repeat(2, 1fr)">
                <GridItem>
                  <TextInput
                    name="adminFirstName"
                    label="First Name"
                    placeholder="First Name"
                  />
                </GridItem>
                <GridItem>
                  <TextInput
                    name="adminLastName"
                    label="Last Name"
                    placeholder="Last Name"
                  />
                </GridItem>
                <GridItem>
                  <TextInput
                    name="adminEmail"
                    label="Email"
                    placeholder="Email"
                  />
                </GridItem>
                <GridItem colStart={1}>
                  <ImageUploader name="adminPicture" label="Picture" />
                </GridItem>
              </Grid>
              <Form.Controls submitText="Save">
                <Button
                  as={Link}
                  to="/organization-management"
                  colorScheme="gray"
                  variant="outline"
                >
                  Cancel
                </Button>
              </Form.Controls>
            </AccordionItem>
          </Box>
        </Form>
      </Box>
    </>
  );
};

export default Create;
